import React from 'react';
import TransitionFormFields from './TransitionFormFields';
import { transitionSchema } from '../../../lib/transition-schemas';

// MaintainedForm — captures maintenance start date + billing cadence + support
// tier on the transition into Maintained. These structured fields drive the
// renewal-window cron and the financial dashboard's renewals widget.
export default function MaintainedForm({ values, onChange, errors }) {
  return <TransitionFormFields schema={transitionSchema('maintained')} values={values} onChange={onChange} errors={errors} />;
}
